import React, { useState, useEffect, FC, useMemo } from 'react';
import './shop-table.scss';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import ShopTableRow from '../shop-table-row/shop-table-row';
import { useSelector } from 'react-redux';

interface ShopTableProps{
  setNewFlavorsPopup: (bool:boolean)=>void;
  setShopIdToDelete: Function;
  setWordToConfirm: Function;
}
const ShopTable:FC<ShopTableProps> = ({setNewFlavorsPopup,  setShopIdToDelete, setWordToConfirm}) => {
    const [search, setSearch] = useState('');
    const shops = useSelector((state: any) => state.shop.shops);
    const [checkedStocks, setCheckedStocks] = useState([]);

    const filteredShops = useMemo(() => {
      if(search == '')
        return shops
      return shops.filter(shop => shop.name.toLowerCase().includes(search.toLowerCase()));
    }, [shops, search]);

    const allChecked = checkedStocks.length === filteredShops.length && filteredShops.length;
    const setAllChecked = (checked: boolean) => {
        if(checked)
            setCheckedStocks(filteredShops.map(stock => stock.id));
        else
            setCheckedStocks([]);
    }
    const setChecked = (checked: boolean, id: string) => {
        if(checked)
            setCheckedStocks([...checkedStocks, id]);
        else
            setCheckedStocks(checkedStocks.filter(stockId => stockId !== id));
    }
    return (
        <div className="shop-table">
            <div className="shop-table__upper">
                <span>Edit columns</span>
                <div className="shop-table__upper__controls">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText placeholder="Search..." className="shop-table__upper__controls__filter-button" onChange={(e)=>setSearch(e.target.value)} />
                    </IconField>
                    <Button onClick={() => setNewFlavorsPopup(true)} icon="pi pi-plus" iconPos='left' label={'Add shop'} className="shop-table__upper__controls__add-button" />
                </div>
           </div>
            <div className="shop-table__table">
                <div className="shop-table__table__header">
                    <Checkbox onChange={e => setAllChecked(e.checked)} checked={allChecked}></Checkbox>
                    <div>Shops</div>
                </div>
                <div className="shop-table__table__body">
                {filteredShops.map((shop) => (
                    <ShopTableRow key={shop.id} {...shop} checked={checkedStocks.includes(shop.id)} setChecked={(checked, id)=>setChecked(checked, id)}  setShopIdToDelete={setShopIdToDelete} setWordToConfirm={setWordToConfirm}/>
                ))}
                </div>
            </div>

        </div>
    );
}
         
export default ShopTable;